export enum SEU_DATE_FORMAT {
  DATE = 'dd.MM.yyyy',
  DATETIME = 'dd.MM.yyyy, HH:mm',
  ELAPSED = 'ELAPSED',
}

export type SeuDateApi = string & { _brand: 'date_api' };
